export const watchtower = state => state.watchtower;
